import { createStyles, Theme } from "@material-ui/core";
export const topNavStyles = (theme: Theme) =>
  createStyles({
    noWrap: {
        whiteSpace: 'nowrap'
    },
    disableText: {
        opacity: 0.7
    },
    disableCard: {
        opacity: 0.5
    },
    contentPopup: {
        margin: '-12px 0px',
        width: 500,
    },
    mtb30:{
        margin: '30px 0',
        textAlign: 'center'
    },
    font16:{
        fontSize: 16,
    },
    infoIconAlign:{
        '& span':{
            verticalAlign: 'middle'
        }
    },
    cardRoot: {
        margin: 10,
        cursor:'pointer',
        // boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        borderRadius:8,
        '&:hover':{
            cursor: 'pointer',
            borderColor: "rgb(195 220 249)",
            textDecoration:"none"
        }
    },
    activeCard:{
        borderColor: "rgb(195 220 249)"
    },
    cardContentRoot: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,        
		'&:last-child': {
            padding: theme.spacing.unit * 2,
            border: '1px solid #CECECE',
            /* card_shadow */
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: 8
        },
        '&:hover':{
            // borderColor: "rgb(195 220 249)",
            textDecoration:"none"
        },
		textAlign: 'center'
    },
    contentTitle:{
        fontSize: 20,
        color: '#333',
        fontWeight: 600,
        marginTop: 15,
    },
    cardImageWrapper:{
        width: 62,
        height: 62,
        borderRadius: '50%',
        padding: 15,
    },
    purpleBG:{
        background: "rgba(184, 129, 227, 0.08)",
    },
    card1:{
        '&:hover':{
            borderColor: '#B881E3'
        }
    },
    greenBG:{
        background: "rgba(114, 201, 54, 0.08)",
    },
    card2:{
        '&:hover':{
            borderColor: '#72C936'
        }
    },  
    blueBG:{
        background: "rgba(74, 184, 255, 0.08)",
    },
    card3:{
        '&:hover':{
            borderColor: '#4AB8FF'
        }
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    link: {
        marginRight: 24,
        fontSize: '1.125rem',
        '&:hover': {
            color: '#333',
            fontWeight: 600
        }
    },
    primaryBtn: {
        background: '#1D7DEA',
        borderRadius: 4,
        maxWidth: 186,
        minHeight: 44
    },
    fontWeight600: {
        fontWeight: 600
    },
    blackColor: {
        color: '#333'
    },
    darkGrey: {
        color: '#999'
    },
    dialogTitle:{
        fontWeight: 600,
        fontSize: 24,
        color: '#333',
        textDecoration: 'none',
        '&:hover':{
          textDecoration:"none"
        },
        '&>a:first-child':{
            textDecoration:'none'
        },
        '& svg':{
            fontSize: '1em',
            cursor: 'pointer',
            verticalAlign: '-4px'
        }
    },
    labelText: {
        '& :nth-child(2)': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: 16,
            lineHeight: '19px',
            color: '#333333',
            marginTop: 2
        }
    },
    HeadingText:{
        fontSize: 18,
        color: '#333',
        marginBottom: 10,
    },
    paddingLeft56: {
        paddingLeft: 56
    },
    backArrow:{
        cursor: 'pointer',
        textDecoration: 'none'
    },
    activeTabStyle:{
        color:'black',
        fontWeight: 600,
        display: 'inline-block',
        position: 'relative',
        '&::before':{
            content: "' '",
            width: "86%",
            height:2,
            backgroundColor: "#333",
            display: "inline-block",
            position: "absolute",
            bottom:-5,
            borderRadius:8,
        }
    },
    infoContainer:{
        margin: '8px 0',
    }

  });

